import { Box, Typography } from '@mui/material'
import React from 'react'
import PlainModal from '../../../../../components/modal/PlainModal'

interface CoinsReceivedProps {
  open: boolean
  handleClose: () => void
  actionButton: () => void
  actionBUttonText: string
  subTitle: string
  title: string
}

const CoinsReceived: React.FC<CoinsReceivedProps> = ({
  handleClose,
  open,
  actionButton,
  actionBUttonText,
  subTitle,
  title,
}) => {
  return (
    <PlainModal
      open={open}
      handleClose={handleClose}
      actionButtonName={actionBUttonText}
      onAction={actionButton}
    >
      <Box
        component="img"
        src="/images/leaderboard/coin-received.gif"
        alt="Background animation"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '60%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
          opacity: 0.4,
        }}
      />

      <Box sx={{ position: 'relative', zIndex: 1, textAlign: 'center', px: 2 }}>
        <Box
          component="img"
          src="/images/leaderboard/coin-yellow.png"
          sx={{
            width: '50px',
            aspectRatio: 1,
            mb: 2,
            mt: 1,
          }}
        />
        <Typography variant="h4" mb={1}>
          {title}
        </Typography>
        <Typography variant="subtitle1">{subTitle}</Typography>
      </Box>
    </PlainModal>
  )
}

export default CoinsReceived
